import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type ReportTemplatesEvents = 'TABLE_NAME_CELL_CLICK';

export const reportTemplates: Record<ReportTemplatesEvents, MixpanelEvent> = {
  TABLE_NAME_CELL_CLICK: {
    eventDescription: 'Report Templates Table Name Cell Click',
    eventKey: 'reportTemplates-table-name-cell-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  }
} as const;
